import Usuario from '@/repositories/Usuario';

// state
const state = () => ({
  usuario: {},
  usuarioPro: {}
});

// getters
const getters = {
  getUsuario: (state) => {
    return state.usuario
  },
  getUsuarioPro: (state) => {
    return state.usuarioPro
  }
};

// mutations
const mutations = {
  SET_USUARIO (state, usuario) {
    state.usuario = usuario
  },
  SET_USUARIO_PRO (state, usuarioPro) {
    state.usuarioPro = usuarioPro
  },
}

// actions
const actions = {
  salvarTutorialCenario ({ commit }, tutorialCenario) {
    Usuario.salvarTutorialCenario(tutorialCenario);
  },
  setUsuario ({ commit }, usuario) {
    commit('SET_USUARIO', usuario)
  },
  setUsuarioPro ({ commit }, usuarioPro) {
    commit('SET_USUARIO_PRO', usuarioPro)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
